export default "__VITE_ASSET__5e00e339__"